<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout align-center justify-center my-5 column>
        <v-flex>
          <img src="@/assets/logo.png" alt="Vuetify.js">
        </v-flex>
        
        <!-- PROD: Ejecución manual de jobs solo para pruebas — no exponer en producción (showJobTestTools=false). -->
        <v-flex v-if="showJobTestTools" xs12 md8 class="mt-5">
          <v-card>
            <v-card-title>
              <span class="headline">Ejecución Manual de Jobs</span>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md6 class="pa-2">
                  <v-card outlined>
                    <v-card-title class="subheading">Carga Masiva, Reporte y Respaldo</v-card-title>
                    <v-card-text>
                      <p class="caption">Ejecuta los jobs individualmente:</p>
                      <ul class="caption" style="margin-left: 20px; margin-top: 8px;">
                        <li>1. Carga Masiva: Procesa documentos desde archivos ZIP/XML del SFTP</li>
                        <li>2. Reporte de Documentos: Genera CSV y lo sube al SFTP</li>
                        <li>3. Respaldo de Facturas: backup de facturas posteadas creadas hoy (zona México)</li>
                      </ul>
                      <p class="caption grey--text">Programado: Diario a las 5:30 AM</p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        small
                        :loading="runningBulkLoad"
                        :disabled="runningBulkLoad || jobStatus.bulkDocumentLoad"
                        @click="executeBulkDocumentLoadOnly"
                        class="ma-1"
                      >
                        <v-icon left small>play_arrow</v-icon>
                        Carga Masiva
                      </v-btn>
                      <v-btn
                        color="primary"
                        small
                        :loading="runningDocumentReport"
                        :disabled="runningDocumentReport || jobStatus.documentReport"
                        @click="executeDocumentReportOnly"
                        class="ma-1"
                      >
                        <v-icon left small>play_arrow</v-icon>
                        Reporte
                      </v-btn>
                      <v-menu
                        v-model="invoiceBackupTestDateMenu"
                        :close-on-content-click="false"
                        offset-y
                        min-width="290px"
                        class="ma-1"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="invoiceBackupTestDate"
                            label="Fecha prueba backup"
                            prepend-icon="event"
                            readonly
                            dense
                            hide-details
                            style="max-width: 150px;"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="invoiceBackupTestDate"
                          locale="es-mx"
                          @input="invoiceBackupTestDateMenu = false"
                        ></v-date-picker>
                      </v-menu>
                      <v-text-field
                        v-model="backupSupplierCode"
                        label="Código proveedor (opcional)"
                        placeholder="ej. SDILOG"
                        hint="Vacío = todos los proveedores del día"
                        persistent-hint
                        dense
                        clearable
                        class="ma-1"
                        style="max-width: 220px;"
                      ></v-text-field>
                      <v-btn
                        color="primary"
                        small
                        :loading="runningInvoiceBackup"
                        :disabled="runningInvoiceBackup || jobStatus.invoiceBackup"
                        @click="executeInvoiceBackupOnly"
                        class="ma-1"
                      >
                        <v-icon left small>play_arrow</v-icon>
                        Respaldo
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>
                
                <v-flex xs12 md6 class="pa-2">
                  <v-card outlined>
                    <v-card-title class="subheading">Sincronización de Archivos</v-card-title>
                    <v-card-text>
                      <p class="caption">Ejecuta el job que sincroniza archivos con el servidor FTP</p>
                      <p class="caption grey--text">Programado: Cada 2 horas (solo producción)</p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        :loading="runningSyncFiles"
                        :disabled="runningSyncFiles || jobStatus.syncFiles"
                        @click="executeSyncFiles"
                      >
                        <v-icon left>play_arrow</v-icon>
                        Ejecutar Job
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>

                <v-flex xs12 md6 class="pa-2">
                  <v-card outlined>
                    <v-card-title class="subheading">Reporte de Documentos (Config.)</v-card-title>
                    <v-card-text>
                      <p class="caption">Ejecuta manualmente el job de reporte configurado.</p>
                      <p
                        class="caption grey--text"
                        v-if="jobReportActiveConfig && jobReportActiveConfig.cronExpr"
                      >
                        Programado: {{ jobReportActiveConfig.cronExpr }}
                      </p>
                      <p class="caption grey--text" v-else-if="jobReportActiveConfig && !jobReportActiveConfig.enabled">
                        Configuración inhabilitada.
                      </p>
                      <p class="caption grey--text" v-else>
                        No hay configuración activa.
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        small
                        :loading="runningJobReportConfig"
                        :disabled="runningJobReportConfig || !jobReportActiveConfig || !jobReportActiveConfig.enabled"
                        @click="executeJobReportConfig"
                        class="ma-1"
                      >
                        <v-icon left small>play_arrow</v-icon>
                        Ejecutar Job Reporte
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-flex>

              </v-layout>
              
              <v-divider class="my-3"></v-divider>
              
              <v-layout row wrap align-center>
                <v-flex xs12>
                  <v-btn
                    small
                    color="info"
                    @click="checkJobStatus"
                    :loading="checkingStatus"
                  >
                    <v-icon left small>refresh</v-icon>
                    Verificar Estado de Jobs
                  </v-btn>
                </v-flex>
                <v-flex xs12 class="mt-2" v-if="Object.keys(jobStatus).length > 0">
                  <v-alert
                    :value="true"
                    type="info"
                    dense
                  >
                    <div v-for="(running, jobName) in jobStatus" :key="jobName">
                      <strong>{{ getJobDisplayName(jobName) }}:</strong> 
                      <span :class="running ? 'red--text' : 'green--text'">
                        {{ running ? 'En ejecución' : 'Disponible' }}
                      </span>
                    </div>
                  </v-alert>
                </v-flex>
                
                <v-flex xs12 class="mt-3" v-if="pendingSyncInfo && pendingSyncInfo.count !== undefined">
                  <v-card outlined>
                    <v-card-title class="subheading">Archivos Pendientes de Sincronizar</v-card-title>
                    <v-card-text>
                      <v-layout row wrap align-center>
                        <v-flex xs12>
                          <p class="headline mb-0">{{ pendingSyncInfo.count }}</p>
                          <p class="caption grey--text">archivos pendientes de sincronizar</p>
                        </v-flex>
                        <v-flex xs12 v-if="pendingSyncInfo.files && pendingSyncInfo.files.length > 0">
                          <v-expansion-panel>
                            <v-expansion-panel-content>
                              <div slot="header">Ver archivos pendientes ({{ pendingSyncInfo.files.length }})</div>
                              <v-list dense>
                                <v-list-tile
                                  v-for="(file, index) in pendingSyncInfo.files"
                                  :key="index"
                                >
                                  <v-list-tile-content>
                                    <v-list-tile-title>{{ file.filename }}</v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      {{ file.vendorName }} - Factura: {{ file.invoiceNum }}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </v-list>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-flex>
                        <v-flex xs12 v-if="pendingSyncInfo.count === 0">
                          <v-alert :value="true" type="success" dense>
                            Todos los archivos están sincronizados
                          </v-alert>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>

      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import { events } from '../main';
import moment from 'moment-timezone';
export default {
  name: 'home',
  props: {
    msg: String
  },
  data () {
    return {
      // PROD: true solo en preprod/pruebas para mostrar botones de ejecución manual de jobs.
      showJobTestTools: false,
      useRFC2: false,
      runningBulkLoad: false,
      runningDocumentReport: false,
      runningInvoiceBackup: false,
      runningSyncFiles: false,
      checkingStatus: false,
      jobStatus: {},
      pendingSyncInfo: null,
      backupSupplierCode: '',
      invoiceBackupTestDate: moment.tz('America/Mexico_City').format('YYYY-MM-DD'),
      invoiceBackupTestDateMenu: false,
      testingError: false,
      runningJobReportConfig: false,
      jobReportActiveConfig: null,
      testError: {
        documentId: '',
        webService: null,
        message: '',
        code: '',
        type: 'E'
      },
      webServiceOptions: [
        { text: 'Fase 0 (antes de WS1)', value: 0 },
        { text: 'Web Service 1', value: 1 },
        { text: 'Web Service 2', value: 2 }
      ],
      errorTypeOptions: [
        { text: 'Error', value: 'E' },
        { text: 'Warning', value: 'W' }
      ]
    }
  },
  methods: {
    snack(message) {
      events.$emit('snackbar', message);            
    },
    getUseRFC2() {
      this.$http.post("util/rfc2Switch", {}).then(result => {
        this.useRFC2 = result.body.value;
      });
    },
    setUseRFC2() {
      this.$http.post("util/rfc2Switch", {useRFC2: this.useRFC2}).then();
    },
    truncateDocuments() {
      this.$http.post("util/truncatedocuments").then(r => this.snack("documentos borrados"));
    },
    deletePaymentSupplements() {
      this.$http.post("util/deleteallpaymentsupplements").then(r => {
        this.snack("Complementos de pago borrados");
      })
    },
    executeBulkDocumentLoad() {
      this.runningBulkLoad = true;
      this.$http.post("util/runBulkDocumentLoadJob")
        .then(response => {
          this.snack(`✓ ${response.body.message}`);
          this.checkJobStatus();
        })
        .catch(error => {
          const errorMsg = error.body && error.body.error 
            ? error.body.error 
            : 'Error al ejecutar el job';
          this.snack(`✗ ${errorMsg}`);
          console.error('Error executing bulk document load:', error);
        })
        .finally(() => {
          this.runningBulkLoad = false;
        });
    },
    executeBulkDocumentLoadOnly() {
      this.runningBulkLoad = true;
      this.$http.post("util/runBulkDocumentLoadJobOnly")
        .then(response => {
          this.snack(`✓ ${response.body.message}`);
          this.checkJobStatus();
        })
        .catch(error => {
          const errorMsg = error.body && error.body.error 
            ? error.body.error 
            : 'Error al ejecutar el job de carga masiva';
          this.snack(`✗ ${errorMsg}`);
          console.error('Error executing bulk document load:', error);
        })
        .finally(() => {
          this.runningBulkLoad = false;
        });
    },
    executeDocumentReportOnly() {
      this.runningDocumentReport = true;
      this.$http.post("util/runDocumentReportJobOnly")
        .then(response => {
          this.snack(`✓ ${response.body.message}`);
          this.checkJobStatus();
        })
        .catch(error => {
          const errorMsg = error.body && error.body.error 
            ? error.body.error 
            : 'Error al ejecutar el job de reporte';
          this.snack(`✗ ${errorMsg}`);
          console.error('Error executing document report:', error);
        })
        .finally(() => {
          this.runningDocumentReport = false;
        });
    },
    executeInvoiceBackupOnly() {
      this.runningInvoiceBackup = true;
      const payload = {};
      if (this.invoiceBackupTestDate && String(this.invoiceBackupTestDate).trim() !== '') {
        payload.testDate = String(this.invoiceBackupTestDate).trim();
      }
      if (this.backupSupplierCode && String(this.backupSupplierCode).trim() !== '') {
        payload.supplierCode = String(this.backupSupplierCode).trim();
      }
      payload.waitForCompletion = true;
      payload.generateUploadedZip = true;
      this.$http.post("util/runInvoiceBackupJobOnly", payload)
        .then(response => {
          this.snack(`✓ ${response.body.message}`);
          if (response.body && response.body.uploadedZip && response.body.uploadedZip.url) {
            this.snack(`ZIP generado (${response.body.uploadedZip.filesCount || 0} archivos). Descargando...`);
            window.open(response.body.uploadedZip.url, '_blank');
          } else {
            this.snack('No hubo archivos transferidos para generar ZIP en esta corrida.');
          }
          this.checkJobStatus();
        })
        .catch(error => {
          const errorMsg = error.body && error.body.error 
            ? error.body.error 
            : 'Error al ejecutar el job de respaldo';
          this.snack(`✗ ${errorMsg}`);
          console.error('Error executing invoice backup:', error);
        })
        .finally(() => {
          this.runningInvoiceBackup = false;
        });
    },
    executeSyncFiles() {
      this.runningSyncFiles = true;
      this.$http.post("util/runSyncFilesJob")
        .then(response => {
          this.snack(`✓ ${response.body.message}`);
          this.checkJobStatus();
        })
        .catch(error => {
          const errorMsg = error.body && error.body.error 
            ? error.body.error 
            : 'Error al ejecutar el job';
          this.snack(`✗ ${errorMsg}`);
          console.error('Error executing sync files:', error);
        })
        .finally(() => {
          this.runningSyncFiles = false;
        });
    },

    loadJobReportActiveConfig() {
      this.$http.get('JobReportConfig/active')
        .then(response => {
          this.jobReportActiveConfig = response.body;
        })
        .catch(error => {
          if (error.status === 404) {
            this.jobReportActiveConfig = null;
            return;
          }
          console.error('Error loading JobReportConfig/active:', error);
          this.snack('Error al cargar configuración del job de reporte');
          this.jobReportActiveConfig = null;
        });
    },

    executeJobReportConfig() {
      this.runningJobReportConfig = true;
      this.$http.post('JobReportConfig/run', {})
        .then(response => {
          this.snack(`✓ ${response.body && response.body.message ? response.body.message : 'Job iniciado. Check logs.'}`);
        })
        .catch(error => {
          const errorMsg = error.body && (error.body.message || error.body.error)
            ? (error.body.message || error.body.error)
            : 'Error al ejecutar el job de reporte';
          this.snack(`✗ ${errorMsg}`);
          console.error('Error executing JobReportConfig/run:', error);
        })
        .finally(() => {
          this.runningJobReportConfig = false;
        });
    },

    checkJobStatus() {
      this.checkingStatus = true;
      this.$http.get("util/checkJobStatus")
        .then(response => {
          if (response.body && response.body.jobs) {
            this.jobStatus = response.body.jobs;
            const runningJobs = Object.entries(response.body.jobs)
              .filter(([name, running]) => running)
              .map(([name]) => this.getJobDisplayName(name));
            
            // Update pending sync files info
            if (response.body.pendingSyncFiles) {
              this.pendingSyncInfo = response.body.pendingSyncFiles;
            }
            
            if (runningJobs.length > 0) {
              this.snack(`Jobs en ejecución: ${runningJobs.join(', ')}`);
            } else {
              const pendingCount = this.pendingSyncInfo ? this.pendingSyncInfo.count : 0;
              if (pendingCount > 0) {
                this.snack(`Todos los jobs están disponibles. ${pendingCount} archivos pendientes de sincronizar`);
              } else {
                this.snack("Todos los jobs están disponibles y no hay archivos pendientes");
              }
            }
          }
        })
        .catch(error => {
          console.error('Error checking job status:', error);
          this.snack("Error al verificar estado de jobs");
        })
        .finally(() => {
          this.checkingStatus = false;
        });
    },
    getJobDisplayName(jobName) {
      const names = {
        bulkDocumentLoad: 'Carga Masiva de Documentos',
        documentReport: 'Reporte de Documentos',
        invoiceBackup: 'Respaldo de Facturas',
        syncFiles: 'Sincronización de Archivos',
        validateInvoices: 'Validación de Facturas',
        validatePaymentSupplements: 'Validación de Complementos'
      };
      return names[jobName] || jobName;
    },
    testLogError() {
      if (!this.testError.documentId || !this.testError.webService || !this.testError.message) {
        this.snack("Por favor completa todos los campos requeridos");
        return;
      }
      
      this.testingError = true;
      
      const payload = {
        documentId: this.testError.documentId,
        webService: this.testError.webService,
        message: this.testError.message,
        type: this.testError.type || 'E'
      };
      
      if (this.testError.code) {
        payload.code = this.testError.code;
      }
      
      this.$http.post("util/testLogWebServiceError", payload)
        .then(response => {
          this.snack(`✓ Error guardado exitosamente: ${response.body.message}`);
          // Reset form
          this.testError.message = '';
          this.testError.code = '';
        })
        .catch(error => {
          const errorMsg = error.body && error.body.error 
            ? error.body.error 
            : 'Error al guardar el error de prueba';
          this.snack(`✗ ${errorMsg}`);
          console.error('Error testing log:', error);
        })
        .finally(() => {
          this.testingError = false;
        });
    }
  },
  mounted() {
    this.getUseRFC2();
    // PROD: carga config de job reporte solo para la sección de pruebas en home.
    // this.loadJobReportActiveConfig();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

img {
    top: 50%;
    height: 200px;
    width: auto;
    margin-top: 200px;
}
</style>
